"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import SiteWorldMap from "../site-world-map";
import { DesktopOnly } from "../ui/desktop-only";
export default function LogisticsSection() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="px-6 py-12 sm:p-12 lg:p-20 flex-1 flex flex-col justify-center bg-background shadow-xl"><div className="flex items-center justify-start gap-2"><h2 className="text-4xl md:text-5xl font-sans font-bold text-foreground mb-6">LOGÍSTICA</h2><p className="text-xs font-mono text-muted-foreground self-start">L0G-4RP</p></div><p className="text-sm font-mono text-muted leading-relaxed max-w-xl">Optimización de cadenas de suministro mediante inteligencia artificial en tiempo real. Nuestros sistemas predicen demoras, optimizan rutas y coordinan recursos globales con precisión milimétrica.</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col items-center lg:flex-row">{t0}<DesktopOnly><div className="flex flex-1 p-12 min-w-0 items-center justify-center bg-muted/50"><div className="w-full max-w-xl aspect-2/1 rounded-xs overflow-hidden border border-border/20 shadow-2xl"><SiteWorldMap /></div></div></DesktopOnly></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="relative w-full lg:min-h-screen flex flex-col bg-muted">{t1}<div className="relative min-h-[40vh] sm:min-h-[45vh] lg:flex-1 w-full"><Image src="/logistic-section.webp" alt={"Contenedores de log\xEDstica Arpano AI"} fill={true} className="object-cover object-[center_75%]" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}